export const roundNumber = (value: string | number) => {
  const numValue = Number(value);

  if (isNaN(numValue) || value === null) {
    return NaN;
  }

  return Math.round((numValue + Number.EPSILON) * 100) / 100;
};
